import { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { selectUser } from 'app/store/userSlice';
import { shouldUseVasList } from './vasListAccess';

const VasListPage = lazy(() => import('./VasListPage'));

/**
 * Orders for a VAS-only login gets the redesigned VAS list; anyone else gets `fallback`, the page the
 * route rendered before.
 */
export default function VasListGate({ fallback, ...props }) {
  const user = useSelector(selectUser);
  if (!shouldUseVasList(user, props.type)) {
    return fallback;
  }
  return (
    <Suspense fallback={null}>
      <VasListPage {...props} />
    </Suspense>
  );
}
